// src/index.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { NavigationProvider } from './context/NavigationContext';
import './index.css';
import { ChatProvider } from './context/ChatContext';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import API_URL from './config';

// Intercept fetch to add trailing Authorization Header
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  let [resource, config] = args;
  let url = '';
  
  if (typeof resource === 'string') {
    url = resource;
  } else if (resource instanceof Request) {
    url = resource.url;
  }
  
  // Inject standard JWT Header for our backend API
  if (url.startsWith(process.env.REACT_APP_API_URL || `${API_URL}`) && !url.includes('/api/token/') && !url.includes('/api/register/')) {
    const token = localStorage.getItem('access_token');
    if (token) {
      if (resource instanceof Request) {
        resource.headers.set('Authorization', `Bearer ${token}`);
      } else {
        config = config || {};
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`
        };
        args[1] = config;
      }
    }
  }
  
  const response = await originalFetch(...args);
  if (response.status === 401 && !url.includes('/api/token/')) {
     localStorage.removeItem('access_token');
     localStorage.removeItem('refresh_token');
     if (window.location.pathname !== '/login') {
       window.location.href = '/login';
     }
  }
  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <NavigationProvider>
          <ChatProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </ChatProvider>
        </NavigationProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
